/* src/app/core/components/navigation/navigation.component.scss */
.navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  border-top: 3px solid rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  padding: 0.5rem 0.5rem calc(0.5rem + var(--ion-safe-area-bottom, 0));
}
@media (min-height: 700px) {
  .navigation {
    padding: 1.5rem 1.5rem calc(1.5rem + var(--ion-safe-area-bottom, 0));
  }
}
.navigation .navigation-inner {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 1rem;
  align-items: center;
  place-items: center;
}
@media (min-width: 768px) {
  .navigation .navigation-inner {
    max-width: 414px;
    margin: 0 auto;
  }
}
.navigation .nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  opacity: 0.7;
}
.navigation .nav-item img {
  width: 24px;
  height: 24px;
  margin-bottom: 5px;
}
.navigation .nav-item.active {
  color: #fff !important;
  border-bottom: 2px solid #fff;
  opacity: 1 !important;
}
.navigation a {
  display: block;
  position: relative;
  z-index: 1;
  color: white;
}
/*# sourceMappingURL=navigation.component.css.map */
